
import SubclientEditableDetail from "@/components/subclient/SubclientEditableDetail.vue";
import { ISubclientDetailData } from "@/entities";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({
  name: "edit-subclient-page",
  components: {
    SubclientEditableDetail,
  },
})
export default class SubclientEditPage extends Vue {
  @Action("fetchSubclientDetail") fetchSubclientDetail!: (
    idSubclient: number
  ) => Promise<ISubclientDetailData>;

  public subclientDetail: ISubclientDetailData | null = null;

  $refs!: {
    subclientEditableDetail: InstanceType<typeof SubclientEditableDetail>;
  };

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    this.subclientDetail = await this.fetchSubclientDetail(Number(this.$route.params.id));
  }

  async handleFetchSubclientRequired(): Promise<void> {
    this.subclientDetail = await this.fetchSubclientDetail(Number(this.$route.params.id));
    this.$nextTick(() => {
      this.$refs.subclientEditableDetail?.initializeFormData();
    });
  }
}
